import { useState, memo } from "react";
import { Box, Grid, Paper, GridProps } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

import { DashInfoCardDetails } from "components/modals";
import CardIcon from "components/Icons/CardIcons";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    isClickable: {
      cursor: "pointer",
      transition: "all 0.2s",
      "&:hover": {
        background: "var(--grayLv6)",
        boxShadow: "var(--shadow)",
      },
    },
  })
);
interface DashInfoCardProps extends GridProps {
  title?: string;
  value: number[];
  elevation?: number;
  isClickable?: boolean;
  fontSizeTitle?: string;
  fontSizeValue?: string;
  fontWeightTitle?: number;
  fontWeightValue?: number;
  info?: { p: number; m: number; g: number; gg: number };
}

function DashInfoCardTotal({
  value,
  title = "",
  elevation = 1,
  isClickable = false,
  fontSizeTitle,
  info,
  fontSizeValue,
  fontWeightTitle,
  fontWeightValue,
  ...rest
}: DashInfoCardProps) {
  const [openDetails, setOpenDetails] = useState(false);
  const classes = useStyles();

  const handleClick = () => {
    if (isClickable) {
      setOpenDetails(true);
    }
  };
  const detailsTitle = title !== "Total de Armários / Boxes" ? title : "Total";

  return (
    <>
      <Grid item xs={12} sm={6} md={3} xl={2} {...rest}>
        <Paper
          elevation={elevation}
          style={{ padding: "8px 12px" }}
          className={isClickable ? classes.isClickable : ""}
          onClick={handleClick}
        >
          <Grid container spacing={2}>
            <Grid item container xs={3} lg={2} alignItems="center">
              <CardIcon name="total" />
            </Grid>

            <Grid item container xs={9} lg={10} justifyContent="flex-end">
              <Box
                height="80px"
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                alignItems="flex-end"
              >
                <span
                  style={{
                    fontSize: fontSizeTitle ? `${fontSizeTitle}` : "1.4rem",
                    fontWeight: fontWeightTitle ? fontWeightTitle : 400,
                    display: "block",
                    color: "var(--black)",
                  }}
                >
                  {title}
                </span>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  textAlign="right"
                >
                  <span
                    style={{
                      fontSize: "3rem",
                      fontWeight: 600,
                      color: "var(--black)",
                      marginRight: "6px",
                    }}
                  >
                    {value[0] > 0 ? value[0] : "-"}
                  </span>
                  <span
                    style={{
                      fontSize: "1.6rem",
                      fontWeight: 600,
                      color: "var(--black)",
                    }}
                  >
                    {" "}
                    /{" "}
                  </span>
                  <span
                    style={{
                      fontSize: "3rem",
                      fontWeight: 600,
                      color: "var(--black)",
                      marginLeft: "6px",
                    }}
                  >
                    {value[1] > 0 ? value[1] : "-"}
                  </span>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      <DashInfoCardDetails
        title={detailsTitle}
        info={info ? info : { g: 0, gg: 1, m: 4, p: 5 }}
        open={openDetails}
        setOpen={setOpenDetails}
      />
    </>
  );
}

export default memo(DashInfoCardTotal);
